import React, { Component } from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Input, Tag, Flex } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';

import UIContext from 'components/Utils/UIContext';

export const TagsTab = (props: any) => {
	const { t } = useTranslation();
	const uiContext = React.useContext(UIContext);

	const [enteredTags, setEnteredTags] = React.useState<any | null>('');

	let indexedAssigned = {}
	if (props.selection) {
		props.selection.taggings.forEach(t => {
			indexedAssigned[t.tagId] = true
		})
	}

	return <>
		<Flex className="mt-2" vertical>
			<Flex className="text-left mb-05">
				{t('pages.navigator.tabs.tags.title')}

				<Button shape="circle" className="mini ml-auto" onDoubleClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
				}} onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					props.setPreferences(
						'pages',
						'navigator.tags',
						!props.areTagsVisible
					);
				}}>
					<FontAwesomeIcon
						icon={!props.areTagsVisible ? faChevronDown : faChevronUp}
					></FontAwesomeIcon>
				</Button>
			</Flex>
			{props.areTagsVisible && <div className="text-left">
				{(props.allTags || []).length > 0 ? (
					(props.allTags || []).map((currentTag, index) => {
						return (<Tag.CheckableTag
							key={index}
							checked={indexedAssigned[currentTag.id]}
							onClick={() => {
								if (!uiContext.canEdit) return;

								const oldTaggings = props.selection && props.selection.taggings || []

								const newTags = indexedAssigned[currentTag.id] ? oldTaggings.filter(
									(st) =>
										st.tagId !=
										currentTag.id
								) : [
									...oldTaggings,
									{
										tagId: currentTag.id,
										tag: currentTag,
									},
								];

								props.onUpdateStakeholderTags(
									props.selection,
									newTags
								);
							}}
						>
							{currentTag.name}
						</Tag.CheckableTag>
						)
					})
				) : (

					<div style={{ color: 'var(--ant-color-text-tertiary)' }}>
						{t('pages.navigator.no_tag')}
					</div>
				)
				}

			</div>}

			{uiContext.canEdit && !props.scenario && props.areTagsVisible && (
				<div className="mt-1">
					<Input
						key={props.selection ? props.selection.id : 'empty'}
						onChange={(event) => {
							setEnteredTags(
								event.target.value
									? event.target.value.slice(0, 30)
									: ''
							);
						}}
						onKeyDown={async (event) => {
							if (event.key === 'Enter') {
								let newTags = enteredTags.trim().split(',');
								// Create new tags
								await Promise.all(
									newTags.map((t: string) =>
										props.onCreateTag(t)
									)
								);
								setEnteredTags('');
							}
						}}
						value={enteredTags}
						className='TagInput'
						placeholder="Create new tags"
					></Input>
				</div>
			)}
		</Flex>
	</>

};

export default TagsTab;
